import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { OrganizationService } from '../auth/services/organization.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationGuard implements CanActivate {


  constructor(private router: Router, private organizationService: OrganizationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if(!route.paramMap.has('organizationName')) {
        this.router.navigate(['/auth/select-organization']);
        return false;
      }

      const organizationName = route.paramMap.get('organizationName');
      // Check if the organization exists
      const organization = this.organizationService.getSelectedOrganization();

      if(organization && organization.name === organizationName) {
        return true;
      }
      
      this.router.navigate(['/auth/select-organization']);
      return false;
  }
  
}
